var firstName = function() {
  return (window.location.hostname === "hanaandalex.com") ? "Hana" : "Alex"
};

var lastName = function() {
  return (window.location.hostname === "hanaandalex.com") ? "Alex" : "Hana"
};

exports.firstName = firstName;
exports.lastName = lastName;



// WEBPACK FOOTER //
// ./src/Utils.js